export enum ResponseCode {
	success = 200,
	created = 201,
	badRequest = 422,
}

export enum sortOrderValues {
	asc = 'asc',
	desc = 'desc',
}

export enum FieldNames {
	levelId = 'levelId',
	topicId = 'topicId',
	lessonId = 'lessonId',
	activityTypeId = 'activityTypeId',
	title = 'title',

	simplifiedQuestionChinese = 'simplifiedQuestionChinese',
	simplifiedImage = 'simplifiedImage',
	optionSimplified = 'optionSimplified',
	optionAudioSimplified = 'optionAudioSimplified',
	simplifiedCorrectAnswer = 'simplifiedCorrectAnswer',
	traditionalQuestionChinese = 'traditionalQuestionChinese',
	traditionalImage = 'traditionalImage',
	optionTraditional = 'optionTraditional',
	optionAudioTraditional = 'optionAudioTraditional',
	traditionalCorrectAnswer = 'traditionalCorrectAnswer',
	isSkippable = 'isSkippable',
	traditionalQuestionAudio = 'traditionalQuestionAudio',
	simplifiedQuestionAudio = 'simplifiedQuestionAudio',

	imageSimplified = 'imageSimplified',
	audioSimplified = 'audioSimplified',
	correctAnswerSimplified = 'correctAnswerSimplified',
	imageTraditional = 'imageTraditional',
	audioTraditional = 'audioTraditional',
	correctAnswerTraditional = 'correctAnswerTraditional',
	correctAnswerAudioSimplified = 'correctAnswerAudioSimplified',
	correctAnswerAudioTraditional = 'correctAnswerAudioTraditional',
	traditionalCompleteActivityAudio = 'traditionalCompleteActivityAudio',
	simplifiedCompleteActivityAudio = 'simplifiedCompleteActivityAudio',

	activityData = 'activityData',
	phraseSimplified = 'phraseSimplified',
	phraseTraditional = 'phraseTraditional',

	simplifiedTitle = 'simplifiedTitle',
	traditionalTitle = 'traditionalTitle',
	simplifiedFile = 'simplifiedFile',
	simplifiedBackgroundAudio = 'simplifiedBackgroundAudio',
	simplifiedAudio = 'simplifiedAudio',
	simplifiedIsMicAllowed = 'simplifiedIsMicAllowed',
	simplifiedSpeechToTextFile = 'simplifiedSpeechToTextFile',
	simplifiedSpeechToTextDataArray = 'simplifiedSpeechToTextDataArray',
	traditionalFile = 'traditionalFile',
	traditionalBackgroundAudio = 'traditionalBackgroundAudio',
	traditionalAudio = 'traditionalAudio',
	traditionalIsMicAllowed = 'traditionalIsMicAllowed',
	traditionalSpeechToTextFile = 'traditionalSpeechToTextFile',
	traditionalSpeechToTextDataArray = 'traditionalSpeechToTextDataArray',

	karaokeTitleEnglish = 'karaokeTitleEnglish',
	karaokeTitleChineseTraditional = 'karaokeTitleChineseTraditional',
	karaokeTitleChineseSimplified = 'karaokeTitleChineseSimplified',
	karaokeTitleChinesePinyin = 'karaokeTitleChinesePinyin',
	simplifiedKaraokeLyricsFile = 'simplifiedKaraokeLyricsFile',
	traditionalKaraokeLyricsFile = 'traditionalKaraokeLyricsFile',
	duration = 'duration',

	leftSimplifiedEnglish = 'leftSimplifiedEnglish',
	leftSimplifiedPinyin = 'leftSimplifiedPinyin',
	leftSimplifiedChinese = 'leftSimplifiedChinese',
	simplifiedFileUrl = 'simplifiedFileUrl',
	leftTraditionalEnglish = 'leftTraditionalEnglish',
	leftTraditionalPinyin = 'leftTraditionalPinyin',
	leftTraditionalChinese = 'leftTraditionalChinese',
	rightSimplifiedEnglish = 'rightSimplifiedEnglish',
	rightSimplifiedPinyin = 'rightSimplifiedPinyin',
	rightSimplifiedChinese = 'rightSimplifiedChinese',
	rightTraditionalEnglish = 'rightTraditionalEnglish',
	rightTraditionalPinyin = 'rightTraditionalPinyin',
	rightTraditionalChinese = 'rightTraditionalChinese',
	htmlSourceCode = 'htmlSourceCode',

	titleTraditional = 'traditionalTitleChinese',
	traditionalTitleEnglish = 'traditionalTitleEnglish',
	titleSimplified = 'simplifiedTitleChinese',
	simplifiedTitleEnglish = 'simplifiedTitleEnglish',
	simplifiedImageUrl = 'simplifiedImageUrl',
	simplifiedAudioUrl = 'simplifiedAudioUrl',
	textPronunciationSimplified = 'simplifiedPronunciationText',
	traditionalImageUrl = 'traditionalImageUrl',
	traditionalAudioUrl = 'traditionalAudioUrl',
	textPronunciationTraditional = 'traditionalPronunciationText',
	isTextToSpeech = 'isTextToSpeech',
	isFlashCardText = 'isFlashCardText',
	flashCardCategory = 'categoryId',

	image = 'image',
	isImageToImage = 'isImageToImage',
	chinese = 'chinese',
	pinyin = 'pinyin',
	english = 'english',
	audio = 'audio',
	traditional = 'traditional',
	simplified = 'simplified',
	isForSeasonal = 'isForSeasonal',
}
